import React, {useEffect} from "react";
import ReactDOMServer from 'react-dom/server';
import * as PropTypes from "prop-types";
import {getDisplayDimensions} from "../Wizard/utils";
import {reduce, chunk, delay} from "lodash";
//import OnImagesLoaded from "../uiUtils/onImagesLoaded";

// Using JSX as template language for building Salsesheets / email etc
// todo ?is this better than jsrender.  Does allow preview ro be a react page too if that works


export const pageStyle =`
    @page { 
        size:8.5in 11in; 
        margin: 0.5in 
    }
`;
export const printStyle =`
    @media print {
        * {
          background-color: 'none';
        }
        
        body {
            color: #666666;
            font-family:Arial, Helvetica, sans-serif;
            font-size:12px;
            line-height:16px;
        }
        
        thead { display: table-header-group }
        tfoot { display: table-footer-group }
    }
`;

//todo ? same for all templates
const css = `
    @media print {
         .screen-only {
            display: none;
        }
    }
    body {
        color: #666666;
        font-family:Arial, Helvetica, sans-serif;
        font-size:12px !important;
        line-height:16px !important;
    }
        textarea#styled {
        width: 500px;
        height: 120px;
        color: #666666;
        border: 2px solid #eeeeee;
        font-family:Arial, Helvetica, sans-serif;
        font-size:12px !important;
        line-height:16px !important;
        padding: 10px;
    }
    .print-container>*{
        padding: 5px 0px;
    }
    td {
            font - size:12px !important;
    }
    .button {
        display: inline-block;cursor: pointer;
        -webkit-border-radius: 8px;-moz-border-radius:10px;border-radius: 8px;-o-border-radius: 8px;-ms-border-radius: 8px
        ;margin: 5px 5px 5px 0;
        text-decoration: none;
    }
    .button.print{
        background: #009999;
        color: #fff !important;
        text-transform: none;
        font-size:16px !important;
        font-weight:normal;
        padding:5px 10px 3px 10px;
        border:none;
        min-width: 100px !important;
        height: 40px;
    }
    .button.print:hover {
        background: #007777;
        border:none;
    }
    .synopsis {
        font - style:italic;
    }
    figure {
        float:left;
    }
    figure img {
        border:none
    }
    figcaption {
        font - size: .8em;
        font-weight: bold;
    }
    .categorytd {
        text-transform:capitalize;
    }
    .center
        margin: 0 auto;
    }
`;


function Company({name, address1, city, state, zip, web, phone}){
    return(<>
        {name}
        {address1 && <span><br/>{address1}</span>}
        {(zip || city || state) &&
            <span>
                <br/>{city}
                {city && (zip || state) && <span>,</span>}
                {state} {zip}
            </span>}
        {web && <span><br/>{web}</span>}
        {phone && <span><br/>{phone}</span>}
        </>
    );
}


// Note must be a component to print (because of ref use)
export class SpecSheet extends React.Component {

    constructor(props) {
        super(props);
        this.timer = 0;
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        let {
            subject,
            company = {},
            file_name,
            text,
            fromName,
            asset = {},
            width = 8.5 * 96,  //pageWidth
            height = 595,  // 1056 - 317Footer - 46title - 96 margin
            margin = 48,
            addressWidth = '55%',
            textHeight = 150,
            metroReference,
            creator,
            jobNumber,
            onLoaded = ()=>{},
            onTimeout = ()=>{},
            timeout = 15000,
            getImageUrl = ad=>ad.previewUrl,
            zipUrl
        } = this.props;

        if (!metroReference) { // ugly - ignore blank data run
            return <div/>
        }

        const contentWidth = width - 2*margin;
        const date = new Date().toLocaleString();

        const imageStyle ={display:'inline-block'};
        let maxImageSize;
        if (asset.height>asset.width){
            imageStyle.height = height;
            maxImageSize=height;
        } else {
            imageStyle.width = contentWidth;
            maxImageSize=contentWidth;
        }

        console.log('starting load...');
        this.timer = delay(onTimeout, timeout);

        const loadedImage = ()=>{
            console.log('Image loaded - calling onLoaded');
            clearTimeout(this.timer);
            delay(onLoaded);
        };

        return (
            <div style={{width:contentWidth, textAlign: 'center'}}>
                    <h2><ReturnText text={subject}/></h2>
                    <img
                        src={getImageUrl(this.props, maxImageSize)} alt={'spec ad'}
                        style={imageStyle}
                        onLoad={loadedImage}
                        onError={()=>{clearTimeout(this.timer);onTimeout()}}
                    />
                    <br/><br/>
                    <div style={{width:contentWidth, textAlign: 'left', display:'inline-block',
                        marginBottom:5}}>
                        <div style={{width: addressWidth, float: 'left'}}>
                            <Company {...company} />
                        </div>
                        <div style={{marginLeft: addressWidth}}>
                            {jobNumber &&
                                <span>Job Number: {jobNumber}<br/></span>}
                            Template Name: {file_name}<br/>
                            Ad Size: {getDisplayDimensions(asset)}<br/>
                            Ad may appear smaller or larger than actual size.
                        </div>
                    </div>
                    <br/>
                    <textarea
                        style={{background: "none repeat scroll 0% 0% white",
                            height: textHeight, width:contentWidth,}}
                        name="styled-textarea"
                        id="styled"
                        readOnly={true}
                        value={text}/>
                    <br/>
                    {zipUrl && <div style={{fontSize:'bigger'}}>
                        Click <a href={zipUrl}>here</a> to download production files
                    </div>}
                    <div style={{width:contentWidth, textAlign: 'left', display:'inline-block'}}>
                        <div style={{width: '50%', float: 'left'}}>
                            {metroReference &&
                                <span>Metro Ref: {metroReference}</span>}
                        </div>
                        <div style={{marginLeft: '50%', textAlign: 'right'}}>
                            Created by {fromName||creator} on {date}
                        </div>
                    </div>
            </div>
        );
    }
}

SpecSheet.propTypes = {
    img_src: PropTypes.any,
    company: PropTypes.any,
    file_name: PropTypes.any,
    text: PropTypes.any,
    fromName: PropTypes.any,
    asset: PropTypes.any
};


export class SalesSheet extends React.Component {
    render() {
        let {
            subject,
            img_src,
            company = {},
            file_name,
            text,
            fromName,
            asset = {},
            width = 8.5 * 96,  //pageWidth
            height = 590,  // 1056 - 317Footer - 46title - 96 margin - 5  cause
            margin = 48,
            addressWidth = '55%',
            textHeight = 150,
            metroReference,
            creator,
            jobNumber,
            ads = [],
            gridGap = 16,
            columns = 0,
            onLoaded = ()=>{},
            onTimeout = ()=>{},
            timeout = 30000,
            getImageUrl = ad=>ad.previewUrl
        } = this.props;

        if (!metroReference) { // ugly - ignore blank data run
            return <div/>
        }

        const date = new Date().toLocaleString();
        const contentWidth = width - 2*margin;

        if (columns===0) {
            ({columns} = getGridSize(ads, {maxWidth: 4}));
        }

        const metaDataHeight = 44; // 2* 22 line height + 6 cause
        const maxImageSize = (height + gridGap) / columns - (metaDataHeight + gridGap);

        const trStyle = {pageBreakInside: 'avoid'};

        const tdStyle={
            verticalAlign:'bottom',
            padding: gridGap /2
        };

        console.log('rendering ss');
        let timer = 0, loaded = 0;
        if (ads.length > 0) {
            console.log('starting load...');
            timer = delay(onTimeout, timeout);
        }

        const loadedImage = ()=>{
            console.log('Images loaded: '+ (loaded+1));
              if (++loaded>=ads.length) {
                  console.log('Calling onLoaded');
                  clearTimeout(timer);
                  delay(onLoaded);
              }
        };


        //todo ?adjust timeout  absed on #of images
        return (
            <table className={'presentation'}
                   style={{width: contentWidth,
                       textAlign: 'center', borderCollapse: 'collapse'
                   }}>
                <thead><tr><td colSpan={columns} >
                    <h2><ReturnText text={subject}/></h2>
                </td></tr></thead>
                <tbody>
                    {chunk(ads, columns).map((rowAds, row)=>
                        <tr key={row} style={trStyle}>
                            {rowAds.map( ad=>
                                <td key={ad.metroReference} style={tdStyle}>
                                    <img
                                        src={getImageUrl(ad, maxImageSize)} alt={'spec ad'}
                                        style={ad.asset.height>ad.asset.width
                                            ?{height:maxImageSize}
                                            :{width:maxImageSize}
                                        }
                                        onLoad={loadedImage}
                                        onError={()=>{clearTimeout(timer);onTimeout()}}
                                    /><br/>
                                    {ad.jobNumber || ad.metroReference}<br/>
                                    {ad.file_name}
                                </td>
                            )}
                        </tr>
                    )}
                </tbody>
                <tfoot><tr ><td colSpan={columns}>
                    <br/><br/>
                    <div style={{width:contentWidth, textAlign: 'left', display:'inline-block',
                        marginBottom:5}}>
                        <div style={{width: addressWidth, float: 'left'}}>
                            <Company {...company} />
                        </div>
                        <div style={{marginLeft: addressWidth}}>
                            {jobNumber &&
                            <span>Job Number: {jobNumber}<br/></span>}
                            # of Ads: {ads.length}<br/>
                        </div>
                    </div>
                    <br/>
                    <textarea
                        style={{background: "none repeat scroll 0% 0% white",
                            height: textHeight, width: contentWidth}}
                        name="styled-textarea"
                        id="styled"
                        readOnly={true}
                        value={text}/>
                    <br/>
                    <div style={{
                        width:contentWidth,
                        textAlign: 'left',
                        display:'inline-block',
                        whiteSpace: 'nowrap'
                    }}>
                        <div style={{width: '40%', float: 'left'}}>
                            {metroReference &&
                            <span>Metro Ref: {metroReference}</span>}
                        </div>
                        <div style={{marginLeft: '40%', textAlign: 'right'}}>
                            Created by {fromName||creator} on {date}
                        </div>
                    </div>
                </td></tr></tfoot>
            </table>
        );
    }
}

SalesSheet.propTypes = {
    img_src: PropTypes.any,
    company: PropTypes.any,
    file_name: PropTypes.any,
    text: PropTypes.any,
    fromName: PropTypes.any,
    asset: PropTypes.any
};
/*
export function EmailSpecad({
                                title,
                                img_src,
                                company,
                                file_name,
                                text,
                                senderName,  // Profile.CN
                                asset
                            }){

    return (
        <html>
        <head>
            <title>{title}</title>
            <style>{css}</style>
        </head>
        <body>
        <div className='print-container center'>
            <img
                src={img_src} alt={'spec ad'}
                style={{maxHeight:600,maxWidth:600}}
            />
            <PropTable data={company} order={['name','address1','city','state','web','phone']} />
            <div >
                Ad File Name: {file_name}&nbsp;&nbsp;&nbsp;Ad File Size: {adSize(asset)}<br/>
                Ad may appear smaller or larger than actual size.
            </div>
            <textarea
                style={{background: "none repeat scroll 0% 0% white",height:150}}
                name="styled-textarea"
                id="styled"
                readOnly={true}
                value={text} />
            <div>
                Sent by {senderName}
            </div>
        </div>
        </body>
        </html>);
}
*/
/*
export function getEmailHTML(info){
    return ReactDOMServer.renderToStaticMarkup(EmailSpecad(info));
}

 */


export function getSpecSheetHTML(info){
    return getHTMLDoc({
        title: info.subject,
        style: printStyle,
        children: <SpecSheet {...info}/>
    });
}

export function getSalesSheetHTML(info){
    return getHTMLDoc({
        title: info.subject,
        style: printStyle,
        children: <SalesSheet {...info}/>
    });
}

export function getHTMLDoc({title, children, style}){
    return ReactDOMServer.renderToStaticMarkup(
        <html>
        <head>
            <title>{title}</title>
            <style>
                {printStyle}
            </style>
        </head>
        <body>
            {children}
        </body>
        </html>
    );
}
/*
{adsInfo.map(adInfo=>
            <SpecSheet {...adInfo}
                style={{pageBreakBefore:'always'}}
            />
            )}
 */




// todo ? support allowing space for meta data
const getGridSize = (items, {maxWidth=4, checkAspect=false}={}) =>{

    const size = Math.min(maxWidth, Math.ceil(Math.sqrt(items.length)));
    const grid = {columns: size , rows: Math.ceil(items.length / size)};

    // remove empty row  (redundant if maxWidth has kicked in)
    if (items.length <= grid.columns * (grid.rows -1)) {
        let reduceDim = 'rows';
        if (checkAspect ) {
            //or  remove col based on most common aspect ratio
            const landscapeCount = reduce(items,
                (count, item) => count + (item.width > item.height ? 1 : 0),
                0);
            if (landscapeCount > items.length / 2) {
                reduceDim = 'columns';
            }
        }
        grid[reduceDim]--;
    }

    return grid;
}

//Note: might be able to use css: white-space: pre-line; - not sure about email client support tho
function ReturnText({text='', ...props}) {
    return <>
        {text.split('\n').map((item, key) =>
            <span key={key} {...props}>{item}<br/></span>)}
    </>
}